module.exports = __webpack_public_path__ + "static/media/mx.1fcc3cf0.svg";